import React, { useState } from 'react';
import { Star, Heart, X } from 'lucide-react';
// Helper to generate mock comments
const generateMockComments = () => {
  const names = ['Laura M.', 'Carlos R.', 'Valentina S.', 'Diego P.', 'Ana G.', 'Javier L.', 'Sofía T.', 'Martín C.', 'Camila V.', 'Andrés F.', 'Lucía B.', 'Fernando R.', 'Paula N.', 'Roberto D.', 'Mariana H.'];
  const texts = ['Muy buena la guía! ademas de gustarle la comida, estoy notando muchos cambios en ellos. comen con mas ganas', 'Muy fácil de entender y aplicar. Las recetas son súper prácticas para el día a día.', 'Noté un cambio en el pelo de mi perrita en solo un par de semanas. ¡Brilla muchísimo!', 'Tenía dudas al principio, pero la información es tan clara que me dio confianza para empezar.', 'Lo mejor que pude comprar para la salud de mi mascota. Tiene mucha más energía ahora.', 'Las recetas son geniales y los ingredientes fáciles de conseguir. Totalmente recomendado.', 'Me encantó que no usa términos complicados. Cualquiera puede entenderlo.', 'Mi perro estaba con sobrepeso y con esta alimentación natural está volviendo a su peso ideal.', 'Los bonos son un excelente complemento. Especialmente el de los premios naturales.', 'Vale cada centavo. La tranquilidad de saber que lo estoy alimentando bien no tiene precio.'];
  const dates = ['hace 1 hora', 'hace 3 horas', 'hace 5 horas', 'hace 1 día', 'hace 2 días', 'hace 3 días', 'hace 1 semana'];
  return Array.from({
    length: 40
  }).map((_, i) => ({
    id: `mock-${i}`,
    name: names[i % names.length],
    date: dates[i % dates.length],
    rating: i % 10 === 0 ? 4 : 5,
    text: texts[i % texts.length],
    likes: Math.floor(Math.random() * 45) + 2,
    isLiked: false
  }));
};
const INITIAL_COMMENTS = generateMockComments();
export function CommentsSection() {
  const [comments, setComments] = useState(INITIAL_COMMENTS);
  const [visibleCount, setVisibleCount] = useState(10);
  // New comment state
  const [newName, setNewName] = useState('');
  const [newText, setNewText] = useState('');
  const [newRating, setNewRating] = useState(5);
  const [hoverRating, setHoverRating] = useState(0);
  // Modal state
  const [showModal, setShowModal] = useState(false);
  const handleLike = (id: string) => {
    setComments(comments.map(c => {
      if (c.id === id) {
        return {
          ...c,
          isLiked: !c.isLiked,
          likes: c.isLiked ? c.likes - 1 : c.likes + 1
        };
      }
      return c;
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newName.trim() || !newText.trim()) return;
    const newComment = {
      id: `user-${Date.now()}`,
      name: newName,
      date: 'hace un momento',
      rating: newRating,
      text: newText,
      likes: 0,
      isLiked: false
    };
    setComments([newComment, ...comments]);
    setNewName('');
    setNewText('');
    setNewRating(5);
    setShowModal(true);
  };
  const loadMore = () => {
    setVisibleCount(prev => Math.min(prev + 5, comments.length));
  };
  return <section className="py-16 bg-white" data-id="element-15">
      <div className="max-w-3xl mx-auto px-4" data-id="element-16">
        <h2 className="text-3xl font-bold text-stone-900 mb-8 text-center" data-id="element-17">
          Opiniones de la comunidad
        </h2>

        {/* Review Input Box */}
        <div className="bg-stone-50 rounded-2xl p-6 shadow-sm border border-stone-200 mb-12" data-id="element-18">
          <h3 className="font-bold text-stone-800 mb-4 text-lg" data-id="element-19">
            Dejá tu comentario
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-20">
            <div data-id="element-21">
              <input type="text" placeholder="Tu nombre" value={newName} onChange={e => setNewName(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-stone-300 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all" required data-id="element-22" />
            </div>
            <div data-id="element-23">
              <textarea placeholder="¿Qué te pareció la guía?" value={newText} onChange={e => setNewText(e.target.value)} rows={3} className="w-full px-4 py-3 rounded-xl border border-stone-300 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all resize-none" required data-id="element-24" />
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-25">
              <div className="flex items-center space-x-1" data-id="element-26">
                <span className="text-sm text-stone-600 mr-2 font-medium" data-id="element-27">
                  Calificación:
                </span>
                {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setNewRating(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} className="focus:outline-none" data-id="element-28">
                    <Star className={`w-6 h-6 transition-colors ${star <= (hoverRating || newRating) ? 'fill-yellow-400 text-yellow-400' : 'text-stone-300'}`} data-id="element-29" />
                  </button>)}
              </div>
              <button type="submit" className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-8 rounded-xl shadow-md transition-colors" data-id="element-30">
                Publicar
              </button>
            </div>
          </form>
        </div>

        {/* Comments List */}
        <div className="space-y-6" data-id="element-31">
          {comments.slice(0, visibleCount).map(comment => <div key={comment.id} className="bg-white p-6 rounded-2xl shadow-sm border border-stone-100" data-id="element-32">
              <div className="flex items-start justify-between mb-3" data-id="element-33">
                <div className="flex items-center space-x-3" data-id="element-34">
                  <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700 font-bold text-lg flex-shrink-0" data-id="element-35">
                    {comment.name.charAt(0).toUpperCase()}
                  </div>
                  <div data-id="element-36">
                    <p className="font-bold text-stone-800" data-id="element-37">{comment.name}</p>
                    <p className="text-xs text-stone-500" data-id="element-38">{comment.date}</p>
                  </div>
                </div>
                <div className="flex text-yellow-400" data-id="element-39">
                  {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < comment.rating ? 'fill-current' : 'text-stone-200'}`} data-id="element-40" />)}
                </div>
              </div>
              <p className="text-stone-700 mb-4" data-id="element-41">{comment.text}</p>
              <div className="flex items-center" data-id="element-42">
                <button onClick={() => handleLike(comment.id)} className={`flex items-center space-x-1.5 text-sm font-medium transition-colors ${comment.isLiked ? 'text-pink-600' : 'text-stone-500 hover:text-pink-500'}`} data-id="element-43">
                  <Heart className={`w-5 h-5 ${comment.isLiked ? 'fill-current' : ''}`} data-id="element-44" />
                  <span data-id="element-45">{comment.likes}</span>
                </button>
              </div>
            </div>)}
        </div>

        {/* Load More Button */}
        {visibleCount < comments.length && <div className="mt-10 text-center" data-id="element-46">
            <button onClick={loadMore} className="bg-stone-100 hover:bg-stone-200 text-stone-800 font-bold py-3 px-8 rounded-full transition-colors border border-stone-200" data-id="element-47">
              Cargar 5 comentarios más
            </button>
          </div>}
        {visibleCount >= comments.length && <div className="mt-10 text-center text-stone-500 font-medium" data-id="element-48">
            No hay más comentarios
          </div>}
      </div>

      {/* Success Modal */}
      {showModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-stone-900/50 backdrop-blur-sm" data-id="element-49">
          <div className="bg-white rounded-2xl p-8 max-w-sm w-full shadow-2xl relative animate-in fade-in zoom-in duration-200" data-id="element-50">
            <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-stone-400 hover:text-stone-600 transition-colors" data-id="element-51">
              <X className="w-6 h-6" data-id="element-52" />
            </button>
            <div className="text-center" data-id="element-53">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-54">
                <Star className="w-8 h-8 text-emerald-600 fill-current" data-id="element-55" />
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-56">
                ¡Gracias por tu comentario!
              </h3>
              <p className="text-stone-600 mb-6" data-id="element-57">
                Tu opinión ayuda a la comunidad.
              </p>
              <button onClick={() => setShowModal(false)} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-4 rounded-xl transition-colors" data-id="element-58">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </section>;
}